import SearchOverviewTotalVisitsCompareDataFetcherFactory from "app/components/widget/widget-fetchers/SearchOverviewTotalVisitsCompareDataFetcher";
import { TableWidget } from "app/components/widget/widget-types/TableWidget";

export class SearchOverviewTotalVisitsTableWidget extends TableWidget {
    static getWidgetMetadataType() {
        return "SearchOverviewTotalVisitsTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    constructor() {
        super();
    }

    private dataFetcherFactory() {
        return SearchOverviewTotalVisitsCompareDataFetcherFactory;
    }

    public getFetcherFactory() {
        return this.dataFetcherFactory();
    }
}

SearchOverviewTotalVisitsTableWidget.register();
